<template>
  <div class="page-container">
    <PageHeader title="商户地市" show-breadcrumb>
      <template #actions>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增地市</el-button>
      </template>
    </PageHeader>

    <!-- 搜索面板 -->
    <SearchPanel>
      <el-input v-model.trim="query.ascName" placeholder="地市名称" clearable size="small" @keyup.enter.native="handleSearch" />
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <!-- 表格 -->
    <TablePanel title="地市列表">
      <el-table :data="list" v-loading="loading" size="small" stripe border>
        <el-table-column type="index" label="序号" width="80" align="center" />
        <el-table-column prop="ascName" label="地市名称" min-width="180" />
        <el-table-column prop="ascShopNums" label="商户数量" width="120" align="center" />
        <el-table-column prop="createtime" label="创建时间" width="180" />
        <el-table-column label="操作" width="160" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="mini" class="text-danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogType === 'add' ? '新增地市' : '编辑地市'" :visible.sync="dialogVisible" width="480px" v-dialog-drag-resize>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="地市名称" prop="ascName">
          <el-input v-model.trim="form.ascName" placeholder="请输入地市名称" maxlength="50" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitting" @click="handleSubmit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getAjefShopCityList, saveAjefShopCity, updateAjefShopCity, deleteAjefShopCity } from '@/api/api'

export default {
  name: 'SystemShopCity',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      submitting: false,
      list: [],
      query: { ascName: '' },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      dialogVisible: false,
      dialogType: 'add',
      form: { ascName: '' },
      rules: {
        ascName: [{ required: true, message: '请输入地市名称', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    // 获取商户地市列表
    async fetchList () {
      this.loading = true
      try {
        const res = await getAjefShopCityList({
          ...this.query,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        })
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) {
        this.list = []
        this.page.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () {
      this.query = { ascName: '' }
      this.handleSearch()
    },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    // 新增地市
    handleAdd () {
      this.dialogType = 'add'
      this.form = { ascName: '' }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    // 编辑地市
    handleEdit (row) {
      this.dialogType = 'edit'
      this.form = { ascId: row.ascId, ascName: row.ascName }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    // 提交表单（新增或编辑）
    handleSubmit () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.dialogType === 'add') {
            await saveAjefShopCity(this.form)
            this.$message.success('新增成功')
          } else {
            await updateAjefShopCity(this.form)
            this.$message.success('编辑成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {} finally {
          this.submitting = false
        }
      })
    },
    // 删除地市（逻辑删除）
    async handleDelete (row) {
      await this.$confirm(`确认删除地市「${row.ascName}」？`, '提示', { type: 'warning' })
      try {
        await deleteAjefShopCity({ ascId: row.ascId })
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {}
    }
  }
}
</script>
